// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.IntrestForm_card__\\+CVgG {
  max-width: 720px;
}

.IntrestForm_form__XMUjr {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.IntrestForm_group__lvSL9 {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: var(--space-5) 0;
  border: 0;
  border-top: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
  min-width: 0;
}

.IntrestForm_group__lvSL9 + .IntrestForm_group__lvSL9 {
  border-top: none;
  margin-top: calc(-1 * var(--space-6));
}

.IntrestForm_legend__rU6-u {
  padding: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.45;
  color: var(--text-primary);
}

.IntrestForm_actions__mq4W- {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3) var(--space-5);
  padding-top: var(--space-1);
}

@media (max-width: 560px) {
  .IntrestForm_actions__mq4W- > .ui-btn {
    width: 100%;
  }
}

/* Submitted view */
section.IntrestForm_done__fCF5Q {
  max-width: 560px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.IntrestForm_doneMark__sqDlg {
  display: inline-flex;
  color: var(--secondary);
}

.IntrestForm_doneCopy__kPz4R {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--text-secondary);
  max-width: 46ch;
}

.IntrestForm_doneActions__Gbyyg {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-3);
  padding-top: var(--space-1);
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/IntrestForm.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":["section.card {\n  max-width: 720px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n.group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  margin: 0;\n  padding: var(--space-5) 0;\n  border: 0;\n  border-top: 1px solid var(--border-light);\n  border-bottom: 1px solid var(--border-light);\n  min-width: 0;\n}\n\n.group + .group {\n  border-top: none;\n  margin-top: calc(-1 * var(--space-6));\n}\n\n.legend {\n  padding: 0;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-3) var(--space-5);\n  padding-top: var(--space-1);\n}\n\n@media (max-width: 560px) {\n  .actions > :global(.ui-btn) {\n    width: 100%;\n  }\n}\n\n/* Submitted view */\nsection.done {\n  max-width: 560px;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.doneMark {\n  display: inline-flex;\n  color: var(--secondary);\n}\n\n.doneCopy {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  max-width: 46ch;\n}\n\n.doneActions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var(--space-3);\n  padding-top: var(--space-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `IntrestForm_card__+CVgG`,
	"form": `IntrestForm_form__XMUjr`,
	"group": `IntrestForm_group__lvSL9`,
	"legend": `IntrestForm_legend__rU6-u`,
	"actions": `IntrestForm_actions__mq4W-`,
	"done": `IntrestForm_done__fCF5Q`,
	"doneMark": `IntrestForm_doneMark__sqDlg`,
	"doneCopy": `IntrestForm_doneCopy__kPz4R`,
	"doneActions": `IntrestForm_doneActions__Gbyyg`
};
export default ___CSS_LOADER_EXPORT___;
